<div class="btn-group" *ngIf="canEdit">
    <button
        id="btnCustomAdd"
        *ngIf="customAddText"
        type="button"
        class="btn btn-sm btn-secondary"
        (click)="customActionComponent.showSelectionModal()"
    >
        <fa-icon class="d-none d-sm-inline-block" [icon]="faCheck"></fa-icon> {{ customAddText }}
    </button>

    <button id="btnAdd" *ngIf="showAdd" type="button" class="btn btn-sm btn-secondary" (click)="grid.addItem()">
        <fa-icon class="d-none d-sm-inline-block" [icon]="faPlus"></fa-icon> {{ addText }}
    </button>
    <button
        id="btnDuplicate"
        *ngIf="showDuplicate"
        type="button"
        class="btn btn-sm btn-secondary"
        (click)="grid.addItem(true)"
        [disabled]="!grid.hasItemSelected"
    >
        <fa-icon class="d-none d-sm-inline-block" [icon]="faCopy"></fa-icon> Duplicate
    </button>

    <button
        id="btnEdit"
        *ngIf="showEdit"
        type="button"
        class="btn btn-sm btn-secondary"
        (click)="grid.editItem()"
        [disabled]="!grid.hasItemSelected"
    >
        <fa-icon class="d-none d-sm-inline-block" [icon]="faPencil"></fa-icon> Edit
    </button>

    <button
        id="btnDelete"
        *ngIf="showDelete"
        type="button"
        class="btn btn-sm btn-secondary"
        (click)="grid.deleteItem()"
        [disabled]="!grid.hasItemSelected"
    >
        <fa-icon class="d-none d-sm-inline-block" [icon]="faXmark"></fa-icon> {{ deleteText }}
    </button>

    <button
        id="btnCustomDelete"
        *ngIf="customDeleteText"
        type="button"
        class="btn btn-sm btn-secondary"
        (click)="customActionComponent.removeSelections()"
        [disabled]="!grid.hasItemSelected"
    >
        <fa-icon class="d-none d-sm-inline-block" [icon]="faEraser"></fa-icon> {{ customDeleteText }}
    </button>
</div>
